import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Init the translate service with ucmim settings.
 *
 * This code was only extracted to a service to be used on multiple places,
 * e.g. normal setup and TDS workaround.
 */
@Injectable({
  providedIn: 'root',
})
export class NgxInitializerService {
  private translateService = inject(TranslateService);
  private locale = inject(LOCALE_ID);


  /**
   * Init the translate service with ucmim settings.
   */
  public init() {
    this.translateService.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translateService.use(`${this.locale}`);
  }
}
